import { IListItem } from "venice-ui";
import {
  IMemberAccess,
  IOrgContract,
  IOrgMember,
  IOrgMemberSimple,
} from "../store/interface/organization";
import { UserContract } from "../store/interface/user";
import { dictionary } from "../untils/dictionary";
import { t } from "./userHelper";
import { IPracingProps } from "../components/SingIn/register.types";
import { countryScope } from "./countryHelpers";



export const getContractMembers = (
  contractID: string,
  members: IOrgMember[],
  projectID?: string,
): IOrgMemberSimple[] => {
  const orgMembers: IOrgMemberSimple[] = [];
  const userList = getUsersInContracts(members, contractID, projectID);

  userList.forEach((_user) => {
    if (_user.selected) {
      orgMembers.push({
        id: _user.id,
        email: _user.value as string,
      });
    }
  });

  return orgMembers;
};

export const getUsersInContracts = (
  members: IOrgMember[],
  contractID: string,
  projectID?: string,
) => {
  const users: IListItem[] = [];
  members.forEach((_member) => {
    if (_member.status !== "deleted") {
      const member: IListItem = {
        id: _member.id,
        value: _member.email,
        children: [],
        selected: false,
      };
      _member.access.forEach((_contract) => {
        if (_contract.id === contractID) {
          if (projectID) {
            if (_contract.projects.length > 0) {
              //check if possible
              _contract.projects.forEach((_project) => {
                if (_project === projectID) {
                  //add to scope
                  member.selected = true;
                }
              });
            } else {
              //access to all , so add to scope
              member.selected = true;
            }
          } else {
            // gdy nie podano projectID -> tylko pełny dostęp (projects === []) oznaczamy jako selected
            if (_contract.projects.length === 0) {
              member.selected = true;
            }
          }
        }
      });
      users.push(member);
    }
  });
  return users;
};

export const checkIfUserHaveContract = (
  contractID: string | null | undefined,
  contracts: UserContract[],
) => {
  if (contractID === null || contractID === undefined || contractID === "") {
    return false;
  }

  return contracts.some((_contract) => _contract.contractID === contractID);
};

export const getMemberDetails = (
  members: IOrgMember[],
  memberID: string,
  contracts: IOrgContract[],
) => {
  const member = {
    email: "",
    role: "",
    contracts: [] as IListItem[],
    status: "",
  };
  const found = members.find((_member) => _member.id === memberID);
  if (found) {
    member.email = found.email;
    member.role = found.role || "readOnly";
    member.contracts = getContractForMember(memberID, members, contracts);
    member.status = found.status;
  }
  return member;
};

export const getMemberEmail = (members: IOrgMember[], memberID: string) => {
  let memberEmail = "";
  const found = members.find((_memeber) => _memeber.id === memberID);
  if (found) {
    memberEmail = found.email;
  }
  return memberEmail;
};

export const getLimits = (planKey: string) => {
  const limits = {
    users: 1,
    space: 1,
  };

  switch (planKey.toLocaleLowerCase()) {
    case "demo":
      limits.users = 10;
      limits.space = 500;
      break;
    case "solo":
      limits.users = 1;
      limits.space = 50;
      break;
    case "basic":
      limits.users = 5;
      limits.space = 250;
      break;
    case "premium":
      limits.users = 10;
      limits.space = 500;
      break;
  }
  return limits;
};

export const checkUserLimit = (planKey: string, membersCount: number) => {
  const limits = getLimits(planKey);
  return membersCount < limits.users;
};

export const encryptNip = (fullNip: string): number => {
  const prefixPattern = /^[A-Z]{2}/;
  const result = prefixPattern.test(fullNip) ? fullNip.slice(2) : fullNip;
  return parseInt(result) || 0;
};

export const getCountryName = (countryCode: string): string => {
  return (
    countryScope.find((_country) => _country.value === countryCode)?.label || ""
  );
};

export interface IChangeProps {
  id: string;
  access: IMemberAccess[];
}

export const prepareUsersToSave = (
  members: IOrgMember[],
  list: IListItem[],
  contracts: IOrgContract[],
  contractID: string,
  projectID?: string,
) => {
  const userChanges: IChangeProps[] = [];
  list.forEach((_item) => {
    const change: IChangeProps = {
      id: _item.id,
      access: [],
    };
    const user = members.find((_member) => _member.id === _item.id);
    if (user) {
      const newValue = _item.selected; // true / false
      let changed = false;

      if (projectID) {
        //we go deeper
        const existingAccess = user.access.find(
          (_access) => _access.id === contractID,
        );

        const contractDef = contracts.find(
          (_contract) => _contract.id === contractID,
        );
        const contractProjects = contractDef?.projects || [];

        if (newValue) {
          // add project to contract (or add contract with this project)
          if (existingAccess) {
            // contract exists
            // if existingAccess.projects empty -> means full access -> nothing to do
            if (existingAccess.projects.length === 0) {
              // full access already -> no change
            } else if (!existingAccess.projects.includes(projectID)) {
              // add project
              const newProjects = [...existingAccess.projects, projectID];
              // if now equals all contract projects -> represent as full access (empty array)
              const uniqueNew = Array.from(new Set(newProjects));
              const becomesFull =
                contractProjects.length > 0 &&
                uniqueNew.length === contractProjects.length;
              change.access = user.access.map((a) =>
                a.id === contractID
                  ? { ...a, projects: becomesFull ? [] : uniqueNew }
                  : a,
              );
              changed = true;
            }
          } else {
            // contract does not exist -> add contract with this project
            change.access = [
              ...user.access,
              { id: contractID, projects: [projectID] },
            ];
            changed = true;
          }
        } else {
          // remove project from contract (or remove contract if no projects left)
          if (existingAccess) {
            if (existingAccess.projects.length === 0) {
              // currently full access -> remove only this project => remaining = all contract projects except projectID
              const remaining = contractProjects.filter(
                (p) => p.projectID !== projectID,
              );
              if (remaining.length === 0) {
                // no projects left -> remove contract
                change.access = user.access.filter((a) => a.id !== contractID);
              } else {
                // set explicit projects to remaining (no longer full access)
                change.access = user.access.map((a) =>
                  a.id === contractID
                    ? {
                        ...a,
                        projects: remaining.map((_item) => _item.projectID),
                      }
                    : a,
                );
              }
              changed = true;
            } else {
              // existingAccess has explicit projects -> remove projectID if present
              const newProjects = existingAccess.projects.filter(
                (p) => p !== projectID,
              );
              if (newProjects.length === 0) {
                // remove contract
                change.access = user.access.filter((a) => a.id !== contractID);
              } else {
                change.access = user.access.map((a) =>
                  a.id === contractID ? { ...a, projects: newProjects } : a,
                );
              }
              changed = true;
            }
          }
        }
      } else {
        const existingValue = user.access.find(
          (_access) => _access.id === contractID,
        );

        if (newValue && !existingValue) {
          change.access = [...user.access, { id: contractID, projects: [] }];
          changed = true;
        } else if (!newValue && existingValue) {
          change.access = user.access.filter((_ai) => _ai.id !== contractID);
          changed = true;
        }
      }
      if (changed) {
        userChanges.push(change);
      }
    }
  });
  return userChanges;
};

export const getContractAndProjectIds = (
  contracts: IOrgContract[],
  id: string,
) => {
  const ids = {
    contractID: "",
    projectID: "",
  };
  const findedContract = contracts.find(
    (_contract) => _contract.contractID === id,
  );
  if (findedContract) {
    ids.contractID = findedContract.contractID;
  } else {
    contracts.forEach((_contract) => {
      const findedProject = _contract.projects?.find(
        (_project) => _project.projectID === id,
      );
      if (findedProject) {
        ids.contractID = _contract.contractID;
        ids.projectID = findedProject.projectID;
      }
    });
  }
  return ids;
};

export const getContractOrdProjectName = (
  contracts: IOrgContract[],
  contractID: string,
  projectID?: string,
) => {
  let name = "";
  const findedContract = contracts.find(
    (_contract) => _contract.contractID === contractID,
  );

  if (projectID) {
    contracts.forEach((_contract) => {
      const findedProject = _contract.projects?.find(
        (_project) => _project.projectID === projectID,
      );
      if (findedProject) {
        name = findedProject.projectName;
      }
    });
  } else if (findedContract) {
    name = findedContract.contractName;
  }
  return name;
};

export const getProjectNameInContract = (
  contracts: IOrgContract[],
  projectID: string,
) => {
  let projectName = "";
  contracts.forEach((_contract) => {
    const findedProject = _contract.projects?.find(
      (_project) => _project.projectID === projectID,
    );
    if (findedProject) {
      projectName = findedProject.projectName;
    }
  });
  return projectName;
};

export const getContractForMember = (
  memberID: string,
  members: IOrgMember[],
  contracts: IOrgContract[],
) => {
  const listItem: IListItem[] = [];
  const member = members.find((_member) => _member.id === memberID);
  if (!member) {
    return [];
  }
  member.access.forEach((_access) => {
    const projects: IListItem[] = [];
    if (_access.projects.length > 0) {
      _access.projects.forEach((_projectID) => {
        const contract = contracts.find((_c) => _c.contractID === _access.id);
        const project = contract?.projects?.find(
          (_p) => _p.projectID === _projectID,
        );
        if (contract && project) {
          projects.push({
            id: project.projectID,
            value: project.projectName,
            children: [],
            statusDone: true,
          });
        }
      });
    }
    listItem.push({
      id: _access.id,
      value:
        contracts.find((_c) => _c.contractID === _access.id)?.contractName ||
        "",
      children: projects,
      extend: true,
      statusDone: true,
    });
  });
  return listItem;
};

export const getContracts = (
  contracts: IOrgContract[],
  members: IOrgMember[],
) => {
  const list: IListItem[] = [];
  contracts.forEach((_contract) => {
    const projects: IListItem[] = [];
    if (_contract.projects && _contract.projects.length > 0) {
      _contract.projects.forEach((_project) => {
        const memebersProjectCount = getContractMembers(
          _contract.contractID,
          members,
          _project.projectID,
        ).length;
        projects.push({
          id: _project.projectID,
          value: _project.projectName,
          children: [],
          statusDone: memebersProjectCount > 0,
          statusWarnning: memebersProjectCount === 0,
        });
      });
    }
    const memebersContractCount = getContractMembers(
      _contract.contractID,
      members,
    ).length;
    list.push({
      id: _contract.contractID,
      value: _contract.contractName,
      children: projects,
      extend: true,
      statusDone: memebersContractCount > 0,
      statusWarnning: memebersContractCount === 0,
    });
  });
  return list;
};

export const getAvailableContracts = (
  memberID: string,
  members: IOrgMember[],
  contracts: IOrgContract[],
) => {
  const contractList = getContracts(contracts, members);
  const member = members.find((_member) => _member.id === memberID);
  if (!member) {
    return contractList;
  }
  contractList.forEach((_contract) => {
    const existingAccess = member.access.find(
      (_access) => _access.id === _contract.id,
    );
    if (existingAccess) {
      if (existingAccess.projects.length === 0) {
        _contract.selected = true;
        _contract.children.forEach((_p) => {
          _p.selected = true;
        });
      } else {
        existingAccess.projects.forEach((_projectID) => {
          const projectItem = _contract.children.find(
            (_p) => _p.id === _projectID,
          );
          if (projectItem) {
            projectItem.selected = true;
          }
        });
      }
    }
  });
  return contractList;
};

export const prepareContractsToSave = (list: IListItem[], memberID: string) => {
  const change: IChangeProps = {
    id: memberID,
    access: [],
  };
  list.forEach((_item) => {
    if (_item.selected) {
      change.access.push({ id: _item.id, projects: [] });
    } else if (_item.children.length > 0) {
      const projects: string[] = [];
      _item.children.forEach((_child) => {
        if (_child.selected) {
          projects.push(_child.id);
        }
      });
      if (projects.length > 0) {
        change.access.push({ id: _item.id, projects: projects });
      }
    }
  });

  return [change];
};

export const projectNNameFromOrganization = (
  contracts: IOrgContract[],
  projectID: string,
) => {
  let projectName = "";
  contracts.forEach((_contract) => {
    const findedProject = _contract.projects?.find(
      (_project) => _project.projectID === projectID,
    );
    if (findedProject) {
      projectName = findedProject.projectName;
    }
  });
  return projectName;
};

export const preprePricing = (pricing: IPracingProps[]): IPracingProps[] => {
  const order = ['demo',"solo", "basic", "premium"];
  const orderMap = new Map(order.map((name, index) => [name, index]));

  return [...pricing]
    .sort((a, b) => {
      const ai = orderMap.get(a.name.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
      const bi = orderMap.get(b.name.toLowerCase()) ?? Number.MAX_SAFE_INTEGER;
      if (ai !== bi) return ai - bi;
      return a.name.localeCompare(b.name);
    })
    .map((_item) => {
      _item.users =
        _item.name === "Basic" ? 5 : _item.name === "Premium" ? 10 : 1;
      _item.codeName = _item.name.toLowerCase();
      _item.name = t(
        dictionary[`pricingName_${_item.name}` as keyof typeof dictionary],
      );
      return _item;
    });
};
